import Http from '../http';
import config from '../../config';
import { Logger } from '../../modules/infra/observability/logger';

class ApiTerminal {
  getName() {
    return 'API';
  }

  discoverReaders(readerLocationId) {
    this.readerLocationId = readerLocationId;
    this.terminalSimulatedMode = config.terminalSimulatedMode;

    Logger.log('Discover readers', {
      location: this.readerLocationId,
      simulated: this.terminalSimulatedMode,
      terminalType: this.getName(),
      action: 'Discover readers',
    });

    return Http.get('/stripe-terminal/list-readers', {
      location: readerLocationId,
    }).then(response => ({
      discoveredReaders: response.readers,
    })).catch(() => ({ discoveredReaders: [] }));
  }

  connect(reader) {
    return new Promise((resolve) => {
      this.readerId = reader.id;

      resolve({});
    });
  }

  collectPayment(paymentIntentId) {
    return new Promise((resolve) => {
      this.paymentIntentId = paymentIntentId;

      resolve({
        paymentIntent: {
          paymentIntentId,
        },
      });
    });
  }

  collectRefundPayment(chargeId, amount, currency) {
    Logger.log('Collect refund payment', {
      location: this.readerLocationId,
      simulated: this.terminalSimulatedMode,
      terminalType: this.getName(),
      chargeId,
      amount,
      currency,
      action: 'Collect refund payment',
    });

    throw new Error('Unsupported operation');
  }

  async retrieveReaderState() {
    let reader;

    if (!this.readerId) {
      return null;
    }

    try {
      reader = await Http.get('/stripe-terminal/retrieve-reader', {
        reader_id: this.readerId,
      });
    } catch (e) {
      throw e;
    }

    if (reader.reader_state.action && reader.reader_state.action.status === 'in_progress') {
      await new Promise(resolve => setTimeout(resolve, 2000));

      return this.retrieveReaderState();
    }

    return reader.reader_state;
  }

  async processPayment(paymentIntent, externalConfigOverride) {
    Logger.log('Process payment', {
      location: this.readerLocationId,
      simulated: this.terminalSimulatedMode,
      terminalType: this.getName(),
      action: 'Process payment',
    });

    const configOverride = {};

    if (externalConfigOverride && externalConfigOverride.tipping) {
      configOverride.skip_tipping = externalConfigOverride.tipping.skipTipping;

      if (!externalConfigOverride.tipping.skipTipping) {
        configOverride.amount_eligible = externalConfigOverride.tipping.amountEligible;
      }
    }

    await Http.post('/stripe-terminal/process-payment-intent', {
      reader_id: this.readerId,
      payment_intent_id: paymentIntent.paymentIntentId,
      ...configOverride,
    });

    const readerState = await this.retrieveReaderState();

    if (!readerState) {
      return null;
    }

    if (readerState.action.status === 'failed') {
      return {
        error: {
          message: 'Payment has been failed',
        },
      };
    }

    const updatedPaymentIntent = await Http.get('/stripe-terminal/retrieve-payment-intent', {
      payment_intent_id: paymentIntent.paymentIntentId,
    });

    return { paymentIntent: updatedPaymentIntent.payment_intent };
  }

  processRefund() {
    Logger.log('Process refund', {
      location: this.readerLocationId,
      simulated: this.terminalSimulatedMode,
      terminalType: this.getName(),
      action: 'Process refund',
    });

    throw new Error('Unsupported operation');
  }

  dispose() {
    if (this.readerId) {
      Logger.log('Reader action was cancelled', {
        location: this.readerLocationId,
        simulated: this.terminalSimulatedMode,
        action: 'Reader action was cancelled',
      });

      const readerId = this.readerId;

      this.readerId = null;

      return Http.post('/stripe-terminal/cancel-reader-action', {
        reader_id: readerId,
      });
    }

    return true;
  }

  isConnected() {
    return true;
  }
}

export default new ApiTerminal();
